import React from "react";
import moment from "moment";

import { useEffect, useMemo, useRef, useState } from "react";
import { useParams, useLocation } from "react-router-dom";

// import { useReactToPrint } from "react-to-print";

import { useTranslation } from "react-i18next";

import { IconButton, Button, TextField, ButtonGroup, Tooltip, TableContainer, TableHead, TableRow, Table, TableCell, TableBody, Grid } from "@mui/material";

// import { DeleteDialog } from "../../../commons/dialog.component";
import { FilterBy } from "../../../commons/filter.component";

import { statusColor } from "../../../config";

import CustomDatePicker from "../../../commons/CustomDatePicker";
import ButtonWithAPICallComponent from "../../../commons/ButtonWithAPICall.component";

import {
  getCtmdocs,
  getB5ById,
  getProductUnit,
  getTank,
  updateB5,
  approveB5,
  // deleteB5,
  getB5Pdf,
} from "../../../../services/api";

/** Icon from icons-material */
// import PrintIcon from "@mui/icons-material/Print";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
// import DeleteIcon from "@mui/icons-material/Delete";
// import RepeatOneIcon from "@mui/icons-material/RepeatOne";
import AddTaskIcon from "@mui/icons-material/AddTask";
// import ApprovalIcon from "@mui/icons-material/Approval";
import InfoIcon from "@mui/icons-material/Info";
import ClearIcon from "@mui/icons-material/Clear";
import PostAddIcon from "@mui/icons-material/PostAdd";

import { gColr } from "../../../../utils/color";
import { sumOfField } from "../../../../services/libService";
const initProduct = { id: null, temp: "", quantity: "", unit: null, d15: "", vcf: "", wcf: "", kg: "", l15: "", tank: null };

export const TicketContext = React.createContext();

export function B5ImpDetail({ ticketid, onSaveResponse }) {
  const [t] = useTranslation();
  const { id } = useParams();
  // const location = useLocation();

  const [isAllow, setAllow] = useState(true);
  const [ticketData, setTicketData] = useState();

  const [blk, setBlk] = useState({
    /**
     * impBlk: Import Detail
     * apvBlk: Aproval
     */
    impBlk: false,
    apvBlk: false,
  });

  const [apvData, setApvData] = useState({
    rex_lit: "",
    rex_l15: "",
    rex_kg: "",
    rex_lit_err: "",
    rex_l15_err: "",
    rex_kg_err: "",
  });

  const [impData, setImpData] = useState({
    imp_start_pump: moment(Date.now()).format("YYYY-MM-DD[T]HH:mm"),
    imp_end_pump: moment(Date.now()).format("YYYY-MM-DD[T]HH:mm"),
    b5products: [initProduct],
  });
  // const [hidden, setHidden] = useState(true);
  const fetchNewData = () => {
    getB5ById(id).then((res) => {
      if (res.code === 403) {
        setAllow(false);
        return;
      }
      res.code === 200 && setTicketData(res.data);
    });
  };

  /** TableProduct */
  const renderTable = useMemo(() => {
    return <TableProduct data={ticketData} impData={impData} setImpData={setImpData} />;
  }, [impData, ticketData]);

  const addNewProduct = () => {
    let newProduct = [...impData.b5products, { ...initProduct }];
    setImpData((prev) => ({ ...prev, b5products: newProduct }));
  };

  const handleImpSubmit = () => {
    let object = {
      ...impData,
      imp_quantity: sumOfField(impData.b5products, "quantity"),
      imp_l15: sumOfField(impData.b5products, "l15"),
      imp_kg: sumOfField(impData.b5products, "kg"),
      imp_start_pump: moment(impData.imp_start_pump).format("YYYY-MM-DD HH:mm"),
      imp_end_pump: moment(impData.imp_end_pump).format("YYYY-MM-DD HH:mm"),
    };
    return updateB5(ticketid, object);
  };

  const handleApvSubmit = () => {
    return approveB5(ticketid, apvData);
  };

  const handleImpSubmitResponse = (res) => {
    if (res.code === 200) {
      try {
        let newTicketData = res.data;
        setTicketData(newTicketData);
        onSaveResponse(ticketid);
        setBlk((prev) => ({ ...prev, impBlk: false, apvBlk: false }));
      } catch (error) {}
    }
  };

  useEffect(() => {
    if (!ticketid) return;
    fetchNewData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketid]);

  useEffect(() => {
    if (ticketData && ticketData.b5products.length > 0) {
      setImpData((prev) => ({ ...prev, imp_start_pump: ticketData.imp_start_pump, imp_end_pump: ticketData.imp_end_pump, b5products: ticketData.b5products }));
      setApvData((prev) => ({
        ...prev,
        rex_lit: ticketData.rex_lit,
        rex_l15: ticketData.rex_l15,
        rex_kg: ticketData.rex_kg,
      }));
    }
  }, [ticketData]);
  if (!isAllow) return t("No permission");
  if (ticketData)
    return (
      <TicketContext.Provider value={ticketData}>
        <div style={{ paddingBottom: 10 }}>
          <div style={{ backgroundColor: gColr.toolbar }}>
            <div style={{ position: "relative", display: "flex", justifyContent: "right" }}>
              <ButtonGroup style={{ height: 40 }}>
                <Tooltip title="Thông tin hàng xuất">
                  <Button variant="outlined" color="primary" onClick={() => setBlk((prev) => ({ ...prev, impBlk: false, apvBlk: false }))}>
                    <InfoIcon />
                  </Button>
                </Tooltip>
                {ticketData.receipt?.status !== "FAIL" && (
                  <Tooltip title="Xem bản hiển thị gốc (pdf)">
                    <ButtonWithAPICallComponent
                      variant="outlined"
                      api={() => {
                        return getB5Pdf(ticketid);
                      }}
                      response={(res) => {
                        res.code === 200 && window.open(res.data);
                      }}
                    >
                      <PictureAsPdfIcon />
                    </ButtonWithAPICallComponent>
                  </Tooltip>
                )}
                <Tooltip title="Nhập/Hiệu chỉnh hàng tàu thuỷ">
                  <Button variant="outlined" color="primary" onClick={() => setBlk((prev) => ({ ...prev, impBlk: true, apvBlk: false }))}>
                    <AddTaskIcon />
                  </Button>
                </Tooltip>
                {/* <Tooltip title="Duyệt thông tin vào ERP">
                  <Button variant="outlined" color="primary" onClick={() => setBlk((prev) => ({ ...prev, impBlk: false, apvBlk: true }))}>
                    <ApprovalIcon />
                  </Button>
                </Tooltip> */}
              </ButtonGroup>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <h2>Phiếu xuất: {ticketData.code}</h2>
            <div className={`status ${ticketData.status}`} style={{ color: statusColor[ticketData.status] }}>
              {t(ticketData.status)}
            </div>
          </div>
          <div align="left" style={{ marginBottom: 5 }}>
            <b>
              {t("Kho xuất")} : {ticketData?.exp_inventory_code}
            </b>
          </div>
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell align="left">
                    {t("Mấu/Số phiếu xuất kho")}: {ticketData?.form_no} - {ticketData?.serial}
                  </TableCell>
                  <TableCell align="left">
                    {t("Kho nhập")}: {ticketData?.imp_inventory_code}
                  </TableCell>
                  <TableCell align="left">
                    {t("Tuyến đường")}: {ticketData?.route}
                  </TableCell>
                  <TableCell align="left">
                    {t("Bồn/Bể xuất")}: {ticketData?.exp_tank_code}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    {t("Thời gian bắt đầu bơm")}: {ticketData?.exp_start_pump && moment(ticketData.exp_start_pump).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell align="left">
                    {t("Thời gian kết thúc bơm")}: {ticketData?.exp_end_pump && moment(ticketData.exp_end_pump).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell align="left">
                    {t("Lệnh điều động số")}: {ticketData?.exp_order_no}
                  </TableCell>
                  <TableCell align="left" colSpan={2}>
                    {t("Chứng chỉ kho xuất số/ngày")}: {ticketData?.exp_cert_no}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    {t("Phương tiện")}: {ticketData?.vehicle_no}
                  </TableCell>
                  <TableCell align="left">
                    {t("Đơn vị vận chuyển")}: {ticketData?.provider_name}
                  </TableCell>
                  <TableCell align="left" colSpan={2}>
                    {t("Người điều khiển")}: {ticketData?.driver}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    {t("Phiếu xuất trả KDN")}: {ticketData?.billcode}
                  </TableCell>
                  <TableCell align="left">
                    {t("Ngày phiếu xuất trả KDN")}: {ticketData?.billdate && moment(ticketData.billdate).format("DD/MM/YYYY HH:mm")}
                  </TableCell>

                  <TableCell align="left">
                    {t("Số hợp đồng")}: {ticketData?.contract_no}
                  </TableCell>
                  <TableCell align="left">
                    {t("Ngày hợp đồng")}: {ticketData?.contract_date && moment(ticketData.contract_date).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div>
            <div style={{ margin: "10px 0" }}>
              {/* <div align="left" style={{ marginBottom: 5 }}>
                <b>{t("Thông tin hàng hoá xuất")}:</b>
              </div> */}
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ border: "1px solid lightgray", width: "5%" }}>{t("STT")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{t("Tên hàng hóa")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>{t("Đơn vị tính")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{t("Số lượng")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>{t("Nhiệt độ")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>D15</TableCell>
                      <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>VCF</TableCell>
                      <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>WCF</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>L15</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>Kg</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.id}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.product_name}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.exp_unit}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{Math.round(ticketData.exp_quantity)?.toLocaleString()}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.exp_temp && parseFloat(ticketData.exp_temp)?.toFixed(2)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.exp_d15 && parseFloat(ticketData.exp_d15)?.toFixed(4)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.exp_vcf && parseFloat(ticketData.exp_vcf)?.toFixed(4)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.exp_wcf && parseFloat(ticketData.exp_wcf)?.toFixed(4)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{Math.round(ticketData.exp_l15)?.toLocaleString()}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{Math.round(ticketData.exp_kg)?.toLocaleString()}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>
          {blk.impBlk === false ? (
            <>
              <div style={{ margin: "10px 0" }}>
                <div align="left" style={{ marginBottom: 5 }}>
                  <b>Kho nhập: {ticketData?.imp_inventory_code}</b>
                </div>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell align="left">
                          {t("Thời gian bắt đầu bơm")} : {ticketData.imp_start_pump && moment(ticketData?.imp_start_pump).format("DD/MM/YYY HH:mm")}
                        </TableCell>
                        <TableCell align="left">
                          {t("Thời gian kết thúc bơm")} : {ticketData.imp_end_pump && moment(ticketData?.imp_end_pump).format("DD/MM/YYY HH:mm")}
                        </TableCell>
                        <TableCell align="left">ERP ID: {ticketData?.erp_id}</TableCell>
                        <TableCell align="left">Số CTT ERP: {ticketData?.erp_code}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell align="left">
                          Số lượng ({ticketData?.exp_unit}): {Math.round(ticketData?.imp_quantity)?.toLocaleString()}
                        </TableCell>
                        <TableCell align="left">L15: {Math.round(ticketData?.imp_l15)?.toLocaleString()}</TableCell>
                        <TableCell align="left">Kg: {Math.round(ticketData?.imp_kg)?.toLocaleString()}</TableCell>
                        <TableCell align="left">
                          {t("Chênh lệch")}: {ticketData?.loss} %
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
              <div style={{ margin: "10px 0" }}>
                {/* <div align="left" style={{ marginBottom: 5 }}>
                  <b>Thông tin hàng hóa nhập:</b>
                </div> */}
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ border: "1px solid lightgray", width: "5%" }}>{t("STT")}</TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }}>{t("Bồn/Bể nhập")}</TableCell>
                        <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>{t("Đơn vị tính")}</TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }}>{t("Số lượng")}</TableCell>
                        <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>{t("Nhiệt độ")}</TableCell>
                        <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>D15</TableCell>
                        <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>VCF</TableCell>
                        <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>WCF</TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }}>L15</TableCell>
                        <TableCell style={{ border: "1px solid lightgray" }}>Kg</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ticketData?.b5products?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell style={{ border: "1px solid lightgray" }}>{index + 1}</TableCell>
                          <TableCell style={{ border: "1px solid lightgray" }}>{item.tank_code}</TableCell>
                          <TableCell style={{ border: "1px solid lightgray" }}>{item.unit_code}</TableCell>
                          <TableCell style={{ border: "1px solid lightgray" }}>{Math.round(item.quantity)?.toLocaleString()}</TableCell>
                          <TableCell style={{ border: "1px solid lightgray" }}>{item.temp && parseFloat(item.temp)?.toFixed(2)}</TableCell>
                          <TableCell style={{ border: "1px solid lightgray" }}>{item.d15 && parseFloat(item.d15)?.toFixed(4)}</TableCell>
                          <TableCell style={{ border: "1px solid lightgray" }}>{item.vcf && parseFloat(item.vcf)?.toFixed(4)}</TableCell>
                          <TableCell style={{ border: "1px solid lightgray" }}>{item.wcf && parseFloat(item.wcf)?.toFixed(4)}</TableCell>
                          <TableCell style={{ border: "1px solid lightgray" }}>{Math.round(item.l15)?.toLocaleString()}</TableCell>
                          <TableCell style={{ border: "1px solid lightgray" }}>{Math.round(item.kg)?.toLocaleString()}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </>
          ) : (
            <>{renderTable}</>
          )}

          {blk.apvBlk && (
            <>
              <div style={{ margin: "10px 0" }}>
                <div align="left" style={{ marginBottom: 5 }}>
                  <b>Xác định lượng tái xuất:</b>
                </div>
                <TableContainer>
                  <Table>
                    <TableBody>
                      <TableRow>
                        <TableCell align="left">
                          <TextField
                            type="number"
                            label="LTT"
                            value={apvData.rex_lit}
                            onChange={(e) =>
                              setApvData((prev) => ({
                                ...prev,
                                rex_lit: Math.round(e.target.value),
                                rex_l15: Math.round((e.target.value / ticketData.imp_quantity) * ticketData.imp_l15),
                                rex_kg: Math.round((e.target.value / ticketData.imp_quantity) * ticketData.imp_kg),
                              }))
                            }
                          />
                        </TableCell>
                        <TableCell align="left">
                          <TextField
                            type="number"
                            label="L15"
                            value={Math.round(apvData.rex_l15) || ""}
                            onChange={(e) =>
                              setApvData((prev) => ({
                                ...prev,
                                rex_lit: Math.round((e.target.value / ticketData.imp_l15) * ticketData.imp_quantity),
                                rex_l15: Math.round(e.target.value),
                                rex_kg: Math.round((e.target.value / ticketData.imp_l15) * ticketData.imp_kg),
                              }))
                            }
                          />
                        </TableCell>
                        <TableCell align="left">
                          <TextField
                            type="number"
                            label="KG"
                            value={Math.round(apvData.rex_kg) || ""}
                            onChange={(e) =>
                              setApvData((prev) => ({
                                ...prev,
                                rex_lit: Math.round((e.target.value / ticketData.imp_kg) * ticketData.imp_quantity),
                                rex_l15: Math.round((e.target.value / ticketData.imp_kg) * ticketData.imp_l15),
                                rex_kg: Math.round(e.target.value),
                              }))
                            }
                          />
                        </TableCell>
                        <TableCell>
                          <FilterBy
                            label={t("Re-export Doc")}
                            style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
                            getDataFunc={() => getCtmdocs({ status: 1, organization_id: ticketData?.exp_organization_id, valid_date: moment(ticketData?.exp_start_pump).format("YYYY-MM-DD") })}
                            setDefaultFunc={(option) => setApvData((prev) => ({ ...prev, tntxPETRef: option.find((item) => item.id === ticketData?.tntxPETRef_id) }))}
                            triggerSetDefaultFunc={true}
                            value={apvData.tntxPETRef}
                            getOptionLabel={(option) => `${option.id} - ${option.tntxNo}` || ""}
                            onChange={(e, newValue) => setApvData((prev) => ({ ...prev, tntxPETRef: newValue }))}
                          />
                        </TableCell>
                        <TableCell>
                          <FilterBy
                            label={t("Domestic Doc")}
                            style={{ display: "inline-flex", width: 240, margin: "5px 10px" }}
                            getDataFunc={() => getCtmdocs({ status: 1, organization_id: ticketData?.imp_organization_id, valid_date: moment(ticketData?.exp_start_pump).format("YYYY-MM-DD") })}
                            setDefaultFunc={(option) => setApvData((prev) => ({ ...prev, domesticPETRef: option.find((item) => item.id === ticketData?.domesticPETRef_id) }))}
                            triggerSetDefaultFunc={true}
                            value={apvData.domesticPETRef}
                            getOptionLabel={(option) => `${option.id} - ${option.tntxNo}` || ""}
                            onChange={(e, newValue) => setApvData((prev) => ({ ...prev, domesticPETRef: newValue }))}
                          />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </div>
            </>
          )}
          {/* Button Block */}
          <Grid container direction={"row"} justifyContent={"flex-end"} alignItems={"flex-end"}>
            {blk.apvBlk && (
              <Grid item xs={2}>
                <ButtonGroup variant="contained" size="small" aria-label="small button group">
                  <ButtonWithAPICallComponent api={handleApvSubmit} response={handleImpSubmitResponse}>
                    {t("Xác nhận")}
                  </ButtonWithAPICallComponent>
                  <Button color="error" onClick={() => setBlk((prev) => ({ ...prev, apvBlk: false }))}>
                    {t("Huỷ bỏ")}
                  </Button>
                </ButtonGroup>
              </Grid>
            )}
            {blk.impBlk && (
              <>
                <Grid item xs={"auto"}>
                  <Tooltip title="Nhập thêm hàng">
                    <Button variant="outlined" color="primary" onClick={addNewProduct}>
                      <PostAddIcon />
                    </Button>
                  </Tooltip>
                </Grid>
                <Grid item xs={2}>
                  <ButtonGroup variant="contained" size="small" aria-label="small button group">
                    <ButtonWithAPICallComponent api={handleImpSubmit} response={handleImpSubmitResponse}>
                      {t("Xác nhận")}
                    </ButtonWithAPICallComponent>
                    <Button color="error" onClick={() => setBlk((prev) => ({ ...prev, impBlk: false }))}>
                      {t("Huỷ bỏ")}
                    </Button>
                  </ButtonGroup>
                </Grid>
              </>
            )}
          </Grid>
        </div>
      </TicketContext.Provider>
    );
  return "";
}

export function B5ExpDetail({ ticketid, onSaveResponse, onReplace, onDelete }) {
  const [t] = useTranslation();
  const { id } = useParams();
  // state
  const [isAllow, setAllow] = useState(true);
  const [ticketData, setTicketData] = useState();

  const fetchNewData = () => {
    getB5ById(id).then((res) => {
      if (res.code === 403) {
        setAllow(false);
        return;
      }
      res.code === 200 && setTicketData(res.data);
    });
  };

  // const handleDeleteAction = () => {
  //   return deleteB5(ticketid);
  // };
  // const handleDeleteResponse = (res) => {
  //   if (res.code === 200) {
  //     try {
  //       let newTicketData = JSON.parse(JSON.stringify(ticketData)); // deep clone current ticket data
  //       newTicketData.receipt.status = "DELETED";
  //       setTicketData(newTicketData);
  //       onDelete(ticketid);
  //     } catch (error) {}
  //   }
  // };

  useEffect(() => {
    if (!ticketid) return;
    fetchNewData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ticketid]);

  if (!isAllow) return t("No permission");
  if (ticketData)
    return (
      <TicketContext.Provider value={ticketData}>
        <div style={{ paddingBottom: 10 }}>
          <div style={{ backgroundColor: gColr.toolbar }}>
            <div style={{ position: "relative", display: "flex", justifyContent: "right" }}>
              <ButtonGroup style={{ height: 40 }}>
                {ticketData.receipt?.status !== "FAIL" && (
                  <Tooltip title="Xem file PDF">
                    <ButtonWithAPICallComponent
                      variant="outlined"
                      api={() => {
                        return getB5Pdf(ticketid);
                      }}
                      response={(res) => {
                        res.code === 200 && window.open(res.data);
                      }}
                    >
                      <PictureAsPdfIcon />
                    </ButtonWithAPICallComponent>
                  </Tooltip>
                )}
                {/* <Tooltip title="Phát hành thay thế">
                  <Button variant="outlined" color="primary" onClick={() => history.push({ pathname: `/editticket/${ticketData.receipt.id}`, state: ticketData })}>
                    <RepeatOneIcon />
                  </Button>
                </Tooltip> */}
                {/* <Tooltip title="Huỷ">
                  <ButtonWithAPICallComponent variant="outlined" api={handleDeleteAction} dialogNode={(params) => <DeleteDialog {...params} />} response={handleDeleteResponse}>
                    <DeleteIcon />
                  </ButtonWithAPICallComponent>
                </Tooltip> */}
              </ButtonGroup>
            </div>
          </div>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <h2>Phiếu xuất: {ticketData.code}</h2>
            <div className={`status ${ticketData.status}`} style={{ color: statusColor[ticketData.status] }}>
              {t(ticketData.status)}
            </div>
          </div>
          <div align="left" style={{ marginBottom: 5 }}>
            <b>
              {t("Kho xuất")}: {ticketData.exp_inventory_code}
            </b>
          </div>
          <TableContainer>
            <Table>
              <TableBody>
                <TableRow>
                  <TableCell align="left">
                    {t("Mấu/Số phiếu xuất kho")}: {ticketData?.form_no} - {ticketData?.serial}
                  </TableCell>
                  <TableCell align="left">
                    {t("Kho nhập")}: {ticketData?.imp_inventory_code}
                  </TableCell>
                  <TableCell align="left">Tuyến đường: {ticketData?.route}</TableCell>
                  <TableCell align="left">
                    {t("Bồn/Bể xuất")}: {ticketData?.exp_tank_code}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    {t("Thời gian bắt đầu bơm")}: {ticketData?.exp_start_pump && moment(ticketData.exp_start_pump).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell align="left">
                    {t("Thời gian kết thúc bơm")}: {ticketData?.exp_end_pump && moment(ticketData.exp_end_pump).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                  <TableCell align="left">
                    {t("Lệnh điều động số")}: {ticketData?.exp_order_no}
                  </TableCell>
                  <TableCell align="left" colSpan={2}>
                    {t("Chứng chỉ kho xuất số/ngày")}: {ticketData?.exp_cert_no}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    {t("Phương tiện")}: {ticketData?.vehicle_no}
                  </TableCell>
                  <TableCell align="left">
                    {t("Đơn vị vận chuyển")}: {ticketData?.provider_name}
                  </TableCell>
                  <TableCell align="left" colSpan={2}>
                    {t("Người điều khiển")}: {ticketData?.driver}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">
                    {t("Phiếu xuất trả KDN")}: {ticketData?.billcode}
                  </TableCell>
                  <TableCell align="left">
                    {t("Ngày phiếu xuất trả KDN")}: {ticketData?.billdate && moment(ticketData.billdate).format("DD/MM/YYYY HH:mm")}
                  </TableCell>

                  <TableCell align="left">
                    {t("Số hợp đồng")}: {ticketData?.contract_no}
                  </TableCell>
                  <TableCell align="left">
                    {t("Ngày hợp đồng")}: {ticketData?.contract_date && moment(ticketData.contract_date).format("DD/MM/YYYY HH:mm")}
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">Ghi chú tại kho xuất: {ticketData?.exp_note}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell align="left">Ghi chú tại kho nhập: {ticketData?.imp_note}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
          <div>
            <div style={{ margin: "10px 0" }}>
              {/* <div align="left" style={{ marginBottom: 5 }}>
                  <b>{t("Thông tin hàng hóa")}:</b>
                </div> */}
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ border: "1px solid lightgray", width: "5%" }}>{t("STT")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{t("Tên hàng hóa")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>{t("Đơn vị tính")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{t("Số lượng")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>{t("Nhiệt độ")}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>D15</TableCell>
                      <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>VCF</TableCell>
                      <TableCell style={{ border: "1px solid lightgray", width: "10%" }}>WCF</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>L15</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>Kg</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    <TableRow>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.id}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.product_name}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.exp_unit}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{Math.round(ticketData.exp_quantity)?.toLocaleString()}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.exp_temp && parseFloat(ticketData.exp_temp)?.toFixed(2)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.exp_d15 && parseFloat(ticketData.exp_d15)?.toFixed(4)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.exp_vcf && parseFloat(ticketData.exp_vcf)?.toFixed(4)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{ticketData.exp_wcf && parseFloat(ticketData.exp_wcf)?.toFixed(4)}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{Math.round(ticketData.exp_l15)?.toLocaleString()}</TableCell>
                      <TableCell style={{ border: "1px solid lightgray" }}>{Math.round(ticketData.exp_kg)?.toLocaleString()}</TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </div>

          <div style={{ margin: "10px 0" }}>
            <div align="left" style={{ marginBottom: 5 }}>
              <b>Kho nhập: {ticketData.imp_inventory_code}</b>
            </div>
            <TableContainer>
              <Table>
                <TableBody>
                  <TableRow>
                    <TableCell align="left">
                      {t("Thời gian bắt đầu bơm")} : {ticketData?.imp_start_pump && moment(ticketData?.imp_start_pump).format("DD/MM/YYYY HH:mm")}
                    </TableCell>
                    <TableCell align="left">
                      {t("Thời gian kết thúc bơm")} : {ticketData?.imp_end_pump && moment(ticketData?.imp_end_pump).format("DD/MM/YYYY HH:mm")}
                    </TableCell>
                    <TableCell align="left">ERP ID: {ticketData?.erp_id}</TableCell>
                    <TableCell align="left">Số CTT ERP: {ticketData?.erp_code}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell align="left">
                      Số lượng ({ticketData?.exp_unit}): {Math.round(ticketData?.imp_quantity)?.toLocaleString()}
                    </TableCell>
                    <TableCell align="left">L15: {Math.round(ticketData?.imp_l15)?.toLocaleString()}</TableCell>
                    <TableCell align="left">Kg: {Math.round(ticketData?.imp_kg)?.toLocaleString()}</TableCell>
                    <TableCell align="left">
                      {t("Chênh lệch")}: {ticketData?.loss} %
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </TicketContext.Provider>
    );
  return "";
}

const TableProduct = ({ data, impData, setImpData }) => {
  // boiler plate
  const [t] = useTranslation();
  const location = useLocation();
  const productRef = useRef();

  // methods
  const handleChangeProduct = (index, keyName, value) => {
    let newProduct = [...impData.b5products];
    newProduct[index][keyName] = value;
    switch (keyName) {
      case "temp":
        newProduct[index].temp_error = newProduct[index].temp < 4.5 || newProduct[index].temp > 52 ? "4.50 - 52.00" : undefined;
        break;
      case "d15":
        newProduct[index].d15_error = newProduct[index].d15 < 0.65 || newProduct[index].d15 > 1.01 ? "0.6500 - 1.0100" : undefined;
        break;
      case "vcf":
        newProduct[index].vcf_error = newProduct[index].vcf < 0 || newProduct[index].vcf > 1.0184 ? "0.0000 - 1.0184" : undefined;
        break;
      case "wcf":
        newProduct[index].wcf_error = newProduct[index].wcf < 0.6889 || newProduct[index].wcf > 1.0039 ? "0.6889 - 1.0039" : undefined;
        break;
      default:
        break;
    }
    setImpData((prev) => ({ ...prev, b5products: newProduct }));
  };
  // effect
  useEffect(() => {
    productRef.current = impData.b5products;
  }, [impData.b5products]);

  return (
    <div style={{ paddingBottom: 10 }}>
      <div align="left" style={{ marginBottom: 5 }}>
        <b>Thông tin kho nhập: {data?.imp_inventory_code}</b>
      </div>
      <div style={{ paddingTop: 10, width: "100%", display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gridGap: 20 }}>
        <CustomDatePicker
          format="DD/MM/YYYY HH:mm"
          outputFormat="YYYY-MM-DD HH:mm"
          label={t("Thời gian bắt đầu")}
          value={impData.imp_start_pump}
          onChange={(value) => setImpData((prev) => ({ ...prev, imp_start_pump: value }))}
          sx={{ width: "100%" }}
        />
        <CustomDatePicker
          format="DD/MM/YYYY HH:mm"
          outputFormat="YYYY-MM-DD HH:mm"
          label={t("Thời gian kết thúc")}
          value={impData.imp_end_pump}
          onChange={(value) => setImpData((prev) => ({ ...prev, imp_end_pump: value }))}
          sx={{ width: "100%" }}
        />
      </div>
      <div align="left" style={{ paddingTop: 10, paddingBottom: 10 }}>
        <b>{t("Danh mục hàng nhập kho")}:</b>
      </div>
      <TableContainer>
        <Table>
          <TableRow>
            <TableCell align="left">Số lượng {sumOfField(impData.b5products, "quantity")}</TableCell>
            <TableCell align="left">L15: {sumOfField(impData.b5products, "l15")}</TableCell>
            <TableCell align="left">Kg: {sumOfField(impData.b5products, "kg")}</TableCell>
          </TableRow>
        </Table>
      </TableContainer>

      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{t("STT")}</TableCell>
              <TableCell>{t("Nhập vào bồn")}</TableCell>
              <TableCell>{t("Số lượng")}</TableCell>
              <TableCell>{t("Nhiệt độ")} (℃)</TableCell>
              <TableCell>D15</TableCell>
              <TableCell>VCF</TableCell>
              <TableCell>WCF</TableCell>
              <TableCell>L15</TableCell>
              <TableCell>Kg</TableCell>

              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {impData?.b5products.map((item, index) => (
              <TableRow key={index}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>
                  <FilterBy
                    getDataFunc={() => getTank({ status: 1, inventory_id: data?.imp_inventory_id })}
                    value={item.tank}
                    triggerSetDefaultFunc={true}
                    // setDefaultFunc={(_, option) =>
                    //   handleChangeProduct(
                    //     index,
                    //     "tank",
                    //     option.find((item) => (location.state?.b5products[index]?.tank ? item.id === location.state.b5products[index].tank : item.id === 21))
                    //   )
                    // }
                    onChange={(e, newValue) => handleChangeProduct(index, "tank", newValue)}
                    style={{ width: 100 }}
                    getOptionLabel={(option) => option.code || ""}
                    label={t("Bồn/bể")}
                    disableClearable
                  />
                </TableCell>
                <TableCell>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <TextField
                      size="small"
                      type="number"
                      variant="outlined"
                      inputProps={{ style: { textAlign: "center" } }}
                      style={{ width: "calc(100% - 100px)", minWidth: 100 }}
                      value={item.quantity}
                      onChange={(e) => handleChangeProduct(index, "quantity", e.target.value)}
                    />
                    <FilterBy
                      getDataFunc={() => getProductUnit({ status: 1 })}
                      value={item.unit}
                      triggerSetDefaultFunc={true}
                      setDefaultFunc={(_, option) =>
                        handleChangeProduct(
                          index,
                          "unit",
                          option.find((item) => (location.state?.receiptproduct[index]?.unit ? item.id === location.state.receiptproduct[index].unit : item.id === 21))
                        )
                      }
                      onChange={(e, newValue) => handleChangeProduct(index, "unit", newValue)}
                      filter={(option) => option.status === "ACTIVATED" && [21, 22].includes(option.id)}
                      style={{ width: 100 }}
                      getOptionLabel={(option) => option.name || ""}
                      label={t("Đơn vị tính")}
                      disableClearable
                    />
                  </div>
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    error={Boolean(item.temp_error)}
                    label={item.temp_error}
                    inputProps={{ style: { textAlign: "center" } }}
                    style={{ width: 100 }}
                    value={item.temp}
                    onChange={(e) => handleChangeProduct(index, "temp", e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    error={Boolean(item.d15_error)}
                    label={item.d15_error}
                    inputProps={{ style: { textAlign: "center" } }}
                    style={{ width: 100 }}
                    value={item.d15}
                    onChange={(e) => handleChangeProduct(index, "d15", e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    error={Boolean(item.vcf_error)}
                    label={item.vcf_error}
                    inputProps={{ style: { textAlign: "center" } }}
                    style={{ width: 100 }}
                    value={item.vcf}
                    onChange={(e) => handleChangeProduct(index, "vcf", e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    error={Boolean(item.wcf_error)}
                    label={item.wcf_error}
                    inputProps={{ style: { textAlign: "center" } }}
                    style={{ width: 100 }}
                    value={item.wcf}
                    onChange={(e) => handleChangeProduct(index, "wcf", e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    error={Boolean(item.l15_error)}
                    label={item.l15_error}
                    inputProps={{ style: { textAlign: "center" } }}
                    style={{ width: 100 }}
                    value={item.l15}
                    onChange={(e) => handleChangeProduct(index, "l15", e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <TextField
                    type="number"
                    error={Boolean(item.kg_error)}
                    label={item.kg_error}
                    inputProps={{ style: { textAlign: "center" } }}
                    style={{ width: 100 }}
                    value={item.kg}
                    onChange={(e) => handleChangeProduct(index, "kg", e.target.value)}
                  />
                </TableCell>
                <TableCell>
                  <IconButton
                    variant="contained"
                    color="error"
                    onClick={() => impData.b5products.length > 1 && setImpData((prev) => ({ ...prev, b5products: prev.b5products.filter((item, indexx) => indexx !== index) }))}
                  >
                    <ClearIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};
